import React from 'react'
import Style from '../manageEntities.module.css'

const titleFor = (label, isEditable, canManage) => {
    if (!canManage) return `You don't have permission to change ${label}`
    return isEditable ? label : `${label} cannot be changed for this entity`
}

const EntityToggle = ({ label, isActive, isEditable, canManage, isSaving, onChange }) => (
    <div className={Style.toggleCell}>
        <label
            className={`switch ${Style.switchWrap}`}
            title={titleFor(label, isEditable, canManage)}
        >
            <input
                type="checkbox"
                checked={isActive}
                disabled={!isEditable || !canManage || isSaving}
                aria-label={label}
                onChange={(event) => onChange(event.target.checked)}
            />
            <span className="slider round" />
        </label>
        {isSaving ? <span className={Style.cellSpinner} aria-hidden="true" /> : null}
        {!isEditable || !canManage ? (
            <i className={`uil-lock-alt ${Style.lockIcon}`} aria-hidden="true" />
        ) : null}
    </div>
)

export default EntityToggle
